<template>
    <v-card-iterator
        v-if           = "items"
        :label         = "$t('contract.title')"
        :items         = "items"
        :columns       = "columns"
        :item-height   = "itemHeight"
        :filter-height = "filterHeight"
        :filter        = "filter"
        :key           = "refreshCount"
        class          = "w-100"
        ref="iterator"
    >
        <template v-slot:toolbar>
            <div class="pl-1 v-flex" style="margin-top: -1px;">
                <slot name="toolbar"></slot>
            </div>
        </template>
        <template v-slot:filter>
            <slot name="filter"></slot>
        </template>
        <template v-slot:card="{ item }">
            <div :class = "background(selected, item)">
                <slot name="card" v-bind:item="{ item }" />
            </div>
        </template>
    </v-card-iterator>
</template>

<script>


import VCardIterator from "@/modules/core/components/utils/VCardIterator.vue";

export default {
    name: "CContractCardIterator",

    components: {
        VCardIterator
    },

    props: {
        /**
         * The list of data to be represented as cards in the iterator.
         */
        items: {
            required: false,
            type    : Array,
            default: function () {
                return [];
            }
        },

        selected: {

        },

        /**
         * A filter function used for the card iterators text filter. The filter function has two parameters: the
         * first parameter contains the data of a card, the second the search criterion.
         */
        filter: {
            required: false,
            type    : Function,
        },

        /**
         * CSS class that is specified when the cards of the iterator have been preselected. If this property is
         * set, this CSS class is used for all cards of the iterator
         */
        preselected: {
            required: false,
            type    : String,
            default : function () {
                return null;
            }
        },

        filterHeight: {
            required: false,
            type    : Number,
            default : function () {
                return 0;
            }
        },

        columns: {
            required: false,
            type    : Number,
            default: function () {
                return 1;
            }
        },

        itemHeight: {
            required: false,
            default: function () {
                return 190;
            }
        }
    },

    data: () => ({
        contract        : null,
        refreshCount    : 0,
    }),

    computed: {
    },

    methods: {
        refresh (contract) {
            const index = this.items.findIndex(c => c.id === contract.id);
            if (index >= 0) {
                this.items[index] = contract;
                this.$nextTick(() => {
                    this.$refs.iterator.refresh(this.items[index]);
                });
            } else {
                this.items.unshift (contract);
            }
        },

        background (selected, contract) {
            if (selected && selected.id === contract.id) {
                if (this.preselected) {
                    return "background-selected " + this.preselected;
                }

                return "background-selected"
            }

            if (this.preselected) {
                return this.preselected;
            }

            return null;
        },
    }
}
</script>

<style lang="scss" scoped>

::v-deep .drop-allowed {
    border-width: unset!important;
    border-style: unset!important;
    border-color: unset!important;
}

::v-deep .drop-contract-allowed {
    border-width: 2px;
    border-style: dashed;
    border-color: var(--v-primary-base);
}

</style>
